export default "__VITE_ASSET__BUZZjLFH__"